import "./Panels.css";
import { images } from '../../shared/assets';

type Props = {
  imgSrc?: string;
  imgAlt?: string;
  width?: string;
};

const FullWidthPanel: React.FC<Props> = ({ imgSrc, imgAlt = 'Awasi landscape', width = '100vw' }) => {

  const { carousel } = images.brandHomePage;
  const imgFullImage = carousel.fullImage;

  return (
    <div className="fullwidth" style={{ width }}>
      <img
        src={imgSrc ? imgSrc : imgFullImage}
        alt={imgAlt}        
      />
    </div>
  );
};

export default FullWidthPanel;